const map = {
	"./bg/blog.json": [
		65467,
		[
			5467
		]
	],
	"./bg/environment.json": [
		3988,
		[
			3988
		]
	],
	"./bg/legalPages.json": [
		40480,
		[
			480
		]
	],
	"./bg/pages.json": [
		53469,
		[
			3469
		]
	],
	"./bg/printingGuides.json": [
		23127,
		[
			3127
		]
	],
	"./bg/shopLocations.json": [
		25629,
		[
			5629
		]
	],
	"./bg/translation.json": [
		71022,
		[
			1022
		]
	],
	"./en/blog.json": [
		39607,
		[
			9607
		]
	],
	"./en/environment.json": [
		96424,
		[
			6424
		]
	],
	"./en/legalPages.json": [
		52708,
		[
			2708
		]
	],
	"./en/pages.json": [
		39545,
		[
			9545
		]
	],
	"./en/printingGuides.json": [
		85707,
		[
			5707
		]
	],
	"./en/shopLocations.json": [
		601,
		[
			601
		]
	],
	"./en/translation.json": [
		44362,
		[]
	],
	"./it/blog.json": [
		86861,
		[
			6861
		]
	],
	"./it/environment.json": [
		926,
		[
			926
		]
	],
	"./it/legalPages.json": [
		46418,
		[
			6418
		]
	],
	"./it/pages.json": [
		65935,
		[
			5935
		]
	],
	"./it/printingGuides.json": [
		18869,
		[
			8869
		]
	],
	"./it/shopLocations.json": [
		16459,
		[
			6459
		]
	],
	"./it/translation.json": [
		61708,
		[
			1708
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75498;
module.exports = webpackAsyncContext;